import { keyframes } from "styled-components";

export const contentFadeInAnim = keyframes`
  0% {
     transform: scale(0.9);
     opacity:0;
     transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
  }
  100% {
    transform: scale(1);
    opacity:1;
   } 
`;
export const showCardContentAnim = keyframes`
    0%,
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  `;
export const rotateCardAnim = keyframes`
    0% {
      opacity: 1;
      transform: translateY(0px) rotateY(-180deg);
    }
    100% {
      opacity: 1;
      transform: translateY(0px) rotateY(0deg);
    }
  `;

export const initCardApearAnim = keyframes`
      0% {
      transform: translateY(30px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  `;

export const cardChangeAnim = keyframes`
    0% {
      transform: translateX(50%);
      opacity: 1;
    }
    50% {
      transform: translateX(75%) rotate(20deg);
      opacity: 1;
    }
    90% {
      transform: translateX(200%) rotate(20deg);
      opacity: 1;
    }
    100% {
      transform: translateX(200%) rotate(20deg);
      opacity: 0;
    }
`;

export const whiteBackgroundAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
     }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
     opacity: 1;
    }
  100%{
     opacity:0;
  } 
`;

export const widthChangeAnim = keyframes`
    0% {
      transform: scaleX(0.55);
      opacity: 0;
      animation-timing-function: cubic-bezier(0.17, 0, 0.17, 1)
    }
    100% {
      opacity: 1;
      transform: scaleX(1);
    }
  `;

export const cardClickAnim = keyframes`
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.75);
    animation-timing-function: cubic-bezier(0,0,0,1);
  }
  62.5% {
    transform: scale(1.02);
    animation-timing-function: cubic-bezier(0.75, 0, 0.18, 0.94);
  }
  100% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.27, 0.2, 0.59, 1);
  }
`;

export const cardInitApearAnim = keyframes`
0%{
  transform: translateY(54px);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.17, 0.17, 0.04, 0.91);
}
53% {
  transform: translateY(6px);
  opacity: 1;
  animation-timing-function: cubic-bezier(0.29, 0.35, 0.62, 1);
}
100%{
  opacity: 1;
  transform: translateY(0px);
}
`;
